import React from 'react';
import ProductPageTemplate from '../../components/ProductPageTemplate';

const DATA = {
  hero: {
    label: 'Background Verification & Compliance',
    title: 'Verify candidates and stay compliant, automatically',
    subtitle: 'Automate document collection, AI validation, expiry tracking, and real-time clearance status. Eliminate spreadsheets and endless email chains.',
    gradient: 'linear-gradient(150deg, #0076A3 0%, #234876 50%, #0076A3 100%)',
  },
  sections: [
    {
      label: 'Compliance Automation',
      title: 'Everything you need for workforce compliance',
      features: [
        { icon: '📋', title: 'AI-Generated Requirements', desc: 'Generate compliance document checklists from any job description. Government ID, certifications, background checks — all role-specific.' },
        { icon: '📤', title: 'Automated Document Requests', desc: 'Send verification links to candidates with selectable document requirements. They upload, AI validates.' },
        { icon: '🤖', title: 'AI Document Validation', desc: 'Every uploaded document is checked by AI for type match, name match, expiry date, and potential issues.' },
        { icon: '📅', title: 'Expiry Tracking', desc: 'Track document expiration dates automatically. Get alerted before credentials expire so no one falls out of compliance.' },
        { icon: '✅', title: 'Clearance Status Engine', desc: 'Real-time status: Cleared, Pending, Action Required, Blocked — with specific reasons for any delays.' },
        { icon: '🔔', title: 'Automated Reminders', desc: 'One-click reminders for candidates with missing documents. Track reminder counts and response times.' },
      ],
      columns: 3,
    },
    {
      label: 'Recruiter Dashboard',
      title: 'See who\'s cleared and who\'s blocked — at a glance',
      desc: 'The Verification Dashboard gives recruiters and compliance teams instant visibility into clearance status across all candidates.',
      bullets: ['KPI tiles: Cleared, Pending, Action Required, Blocked', 'Filter by clearance status with one click', 'Per-candidate document detail with AI validation results', 'Manual approve/reject with reason tracking', 'Full audit trail of all compliance events'],
      visual: '📊',
      visualLabel: 'Verification Dashboard',
    },
  ],
  testimonial: { quote: 'The compliance module alone saved us thousands. Document tracking, expiry alerts, and clearance dashboards — all automated.', name: 'Michael R.', role: 'HR Director, FinanceHub' },
  cta: { title: 'Automate your compliance workflow', desc: 'Stop chasing documents. Start verifying candidates in real-time.' },
};

export default function CompliancePage() { return <ProductPageTemplate data={DATA} />; }
